import Separator from '@flatsy/core/Layout/Separator'
import { Body1, Header2 } from '@flatsy/core/MaterialUi/Typo'
import i18n from '@flatsy/utils/translations'
import { Trans } from 'react-i18next'
import React from 'react'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { useMobile } from 'src/hooks/Mobile'
import { renderVerlingue } from 'src/utils/Verlingue'
import { useStyles } from './Style'
import { WaitingProps } from './Type'

const Waiting: React.FC<WaitingProps> = ({ asset }): React.ReactElement => {
  const classes = useStyles()
  const isMobile = useMobile()
  const {
    qualification,
    application: { application },
  } = useApplicationDetails()

  const isSale = asset && asset.is_sale
  const needsUploads = !!qualification?.need_uploads
  const approvalOfFilesRequired = !isSale && needsUploads

  const renderAssetType = () => {
    return isSale ? (
      <Body1 className={classes.textDarkBlue}>
        {i18n.t('have_patience_we_will_get_back_to_you')}
      </Body1>
    ) : (
      <>
        {needsUploads && (
          <>
            <Body1 className={classes.textDarkBlue}>
              <Trans i18nKey="if_you_want_to_get_a_head_start_on_the_rest_of_the_application_process_you_can_start_sending_us_your_supporting_documents_via_the_file_tab" />
            </Body1>

            <Separator size="16px" />
          </>
        )}
        <Body1 className={classes.textDarkBlue}>
          <Trans i18nKey="as_soon_as_the_situation_progresses_you_will_receive_an_email_inviting_you_to_choose_a_viewing_time_until_then_we_will_unfortunately_be_unable_to_give_you_any_further_information_by_telephone" />
        </Body1>
        {needsUploads && (
          <>
            <Separator size="16px" />

            <Body1 className={classes.textDarkBlue}>
              {i18n.t(
                'if_you_abandon_your_application_using_the_‘cancel_my_application’_button_all_your_personal_information_will_be_deleted_otherwise_they_will_be_automatically_deleted_after_a_period_of_three_months'
              )}
            </Body1>
          </>
        )}
      </>
    )
  }

  return (
    <div className={isMobile ? classes.containerMobile : classes.container}>
      <div className={isMobile ? classes.waitingMobile : classes.waiting}>
        <Header2>{i18n.t('how_to_get_a_tour')}</Header2>
        <Body1 className={classes.textWaiting}>
          {i18n.t('you_are_currently_waiting_for_a_tour_of_one_of_our_properties')}
        </Body1>
        <Body1>
          <ul className={classes.darkBlue}>
            <li>{i18n.t('availability_to_tour_the_property_still_unknown').toLowerCase()};</li>
            <li>
              {i18n.t('high_demand_for_this_property').toLowerCase()}
              {approvalOfFilesRequired ? ';' : '.'}
            </li>
            {approvalOfFilesRequired && (
              <li>{i18n.t('approval_of_file_required_prior_to_tour').toLowerCase()}.</li>
            )}
          </ul>
        </Body1>
        {renderAssetType()}
      </div>
      {renderVerlingue(application?.is_verlingue_supported)}
    </div>
  )
}

export default Waiting
